import React, { useMemo } from 'react';
import {
  CheckCircleIcon,
  HomeIcon,
  PhoneIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';
import { useLanguage } from '../../contexts/LanguageContext';

const STATE_CONFIG = [
  {
    key: 'affiliated',
    icon: UsersIcon,
    gradient: 'from-orange-400 to-orange-600',
    iconBg: 'bg-orange-100 text-orange-600  ',
    bar: 'bg-orange-500',
    valueClass: 'text-orange-600',
  },
  {
    key: 'contacted',
    icon: PhoneIcon,
    gradient: 'from-red-400 to-red-600',
    iconBg: 'bg-red-100 text-red-600  ',
    bar: 'bg-red-500',
    valueClass: 'text-red-600',
  },
  {
    key: 'visited',
    icon: HomeIcon,
    gradient: 'from-violet-400 to-violet-600',
    iconBg: 'bg-violet-100 text-violet-600  ',
    bar: 'bg-violet-500',
    valueClass: 'text-violet-600',
  },
  {
    key: 'completed',
    icon: CheckCircleIcon,
    gradient: 'from-emerald-400 to-emerald-600',
    iconBg: 'bg-emerald-100 text-emerald-600  ',
    bar: 'bg-emerald-500',
    valueClass: 'text-emerald-600',
  },
];

function PlatformClientStateBreakdown({ clientStates = {}, className = '', compact = false }) {
  const { t } = useLanguage();
  const adminT = t.admin;

  const labels = {
    affiliated: adminT.affiliated,
    contacted: adminT.contacted,
    visited: adminT.visited,
    completed: adminT.completed,
  };

  const total = useMemo(
    () => Object.values(clientStates).reduce((sum, value) => sum + (value || 0), 0),
    [clientStates]
  );

  return (
    <div className={`grid grid-cols-2 gap-3 ${compact ? '' : 'md:grid-cols-4'} ${className}`}>
      {STATE_CONFIG.map((item) => {
        const Icon = item.icon;
        const count = clientStates[item.key] || 0;
        const pct = total > 0 ? Math.round((count / total) * 100) : 0;

        return (
          <div
            key={item.key}
            className="rounded-2xl border border-secondary-200/80 bg-white/80 p-4 shadow-soft  "
          >
            <div className="mb-3 flex items-center justify-between gap-2">
              <div className={`inline-flex rounded-xl p-2.5 ${item.iconBg}`}>
                <Icon className="h-5 w-5" />
              </div>
              <span className={`text-xs font-semibold tabular-nums ${item.valueClass}`}>{pct}%</span>
            </div>
            <p className="text-xs font-semibold uppercase tracking-wide text-secondary-500 ">
              {labels[item.key]}
            </p>
            <p className={`mt-1 text-2xl font-bold tabular-nums ${item.valueClass}`}>{count}</p>
            <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-secondary-100 ">
              <div className={`h-full rounded-full ${item.bar}`} style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default PlatformClientStateBreakdown;
